import React from "react";
import { useAuth } from "@/lib/auth";
import StepHeader from "./StepHeader";

export default function AccountStep() {
  const { user } = useAuth();
  if (!user) return null;

  return (
    <div className="flex flex-col gap-0 fade-up h-full">
      <StepHeader
        eyebrow="Account · Step 1 of 5"
        title="Account &amp; profile"
        subtitle="This is the tenant analyst we authenticated. Your sub-logins inherit this account."
        done
      />

      <div className="mt-6 grid grid-cols-1 md:grid-cols-2 gap-6">
        <ReadOnly label="First name" value={user.first_name} />
        <ReadOnly label="Last name" value={user.last_name} />
        <ReadOnly label="Email" value={user.email} />
        <ReadOnly label="Role" value={user.role} />
        <ReadOnly label="Tenant scope" value={user.is_primary ? "Primary tenant · full /edi access" : "Sub-login · scoped"} />
        <ReadOnly label="User ID" value={user.id} mono />
      </div>

      <div className="mt-7">
        <div className="text-[10px] font-bold tracking-[0.1em] uppercase text-[var(--gray2)] pb-2 border-b border-black/[.1]">
          Allowed modules
        </div>
        <div className="flex flex-wrap gap-1.5 mt-3">
          {(user.allowed_modules || []).map((m) => (
            <span
              key={m}
              className="text-[10px] font-semibold px-2.5 py-1 rounded-[8px] bg-white/65 border border-black/[.08] text-[var(--ink2)]"
            >
              {m}
            </span>
          ))}
        </div>
      </div>

      <div className="mt-auto pt-5 text-[11px] text-[var(--gray2)] flex items-center gap-2">
        <span className="w-1.5 h-1.5 rounded-full bg-[var(--green)]" />
        Authenticated · 8-hour JWT active
      </div>
    </div>
  );
}

function ReadOnly({ label, value, mono }) {
  return (
    <div className="flex flex-col gap-0.5">
      <span className="lf-label">{label}</span>
      <div
        className={`text-[13px] text-[var(--ink)] font-medium border-b border-black/[.16] py-[7px] ${
          mono ? "font-mono text-[11px] tracking-tight" : ""
        }`}
      >
        {value || "—"}
      </div>
    </div>
  );
}
